import { render, staticRenderFns } from "./Purpose.vue?vue&type=template&id=e9d6b40c&scoped=true&"
import script from "./Purpose.vue?vue&type=script&lang=js&"
export * from "./Purpose.vue?vue&type=script&lang=js&"
import style0 from "./Purpose.vue?vue&type=style&index=0&id=e9d6b40c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9d6b40c",
  null
  
)

export default component.exports